<template>
  <div>
    <div class="mt-4 mb-4">
      <!--Note modal -->
      <b-modal
        id="modal-note"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
        :title="titleModalNote"
      >
        <template #default>
          <alert-error
            v-if="formNote.errors.get('message')"
            :form="formNote"
            :message="formNote.errors.get('message')"
          ></alert-error>
          <form
            @submit.prevent="submitNote"
            @keydown="formNote.onKeydown($event)"
          >
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="note_titre"
                    >Titre <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formNote.errors.has('titre'),
                    }"
                    id="note_titre"
                    v-model="formNote.titre"
                    type="text"
                    placeholder="Titre"
                    maxlength="50"
                    :required="modeNote !== 'show'"
                    :disabled="modeNote === 'show'"
                  />
                  <has-error :form="formNote" field="titre"></has-error>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="date"
                    >Date <span class="text-danger">*</span></label
                  >
                  <date-picker
                    v-model="formNote.date"
                    name="date"
                    placeholder="Date"
                    lang="fr"
                    format="DD/MM/YYYY"
                    value-type="DD/MM/YYYY"
                    :required="modeNote !== 'show'"
                    :disabled="modeNote === 'show'"
                  ></date-picker>
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formNote.errors.has('date'),
                    }"
                    type="hidden"
                  />
                  <has-error :form="formNote" field="date"></has-error>
                </div>
              </div>

              <div class="col-md-12 mt-n4">
                <div class="form-group">
                  <label for="note_description"
                    >Description (max : 500 caractères )
                    <span class="text-danger">*</span></label
                  >
                  <textarea
                    id="note_description"
                    v-model="formNote.description"
                    class="form-control"
                    :class="{
                      'is-invalid': formNote.errors.has('description'),
                    }"
                    rows="5"
                    maxlength="500"
                    :required="modeNote !== 'show'"
                    :disabled="modeNote === 'show'"
                  ></textarea>
                  <has-error :form="formNote" field="description"></has-error>
                </div>
              </div>
              <div class="px-3 mt-3" v-if="modeNote === 'show'">
                <span class="mr-2 text-custom-primary"
                  ><i class="far fa-user text-custom-primary mr-1"></i> Auteur:
                </span>
                <span>{{ formNote.auteur.nom }}</span>
              </div>
            </div>
          </form>
        </template>
        <template #modal-footer>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="$bvModal.hide('modal-note')"
          >
            Fermer
          </button>

          <button
            v-if="modeNote !== 'show'"
            type="submit"
            class="btn btn-custom-primary w-40"
            @click="submitNote"
            style="min-width: 100px"
          >
            {{ modeNote === 'create' ? 'Créer' : 'Enregistrer' }}
          </button>
        </template>
      </b-modal>

      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="showNoteModal(null)"
              >
                <i class="fas fa-plus"></i>
                Nouvelle note
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionNote"
                v-show="isSelectNote"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <NoteDataTable
                ref="datatableNote"
                @onSelect="onSelectNoteRows"
                @onRowShow="showNoteModal"
                @onRowEdit="editNoteModal"
                @onRowsDelete="deleteNoteRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/mission_tache/tache';
import NoteDataTable from './DataTable.vue';
import DatePicker from 'vue2-datepicker';

import From from 'vform';
export default {
  data() {
    return {
      formNote: new From({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        titre: '',
        description: '',
      }),

      currentTache: '',

      modeNote: 'create',
      titleModalNote: 'Ajout de nouvelle note',
      isSelectNote: false,
    };
  },
  components: {
    NoteDataTable,
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    /**
     * Modal note
     */
    async showNoteModal(id) {
      if (id) {
        this.titleModalNote = "Aperçu d'une note";
        this.formNote.reset();
        this.formNote.clear();
        this.modeNote = 'show';

        await window.axios
          .get(URL.NOTE + '/' + id)
          .then((resp) => {
            Object.assign(this.formNote, resp.data.tacheNote);
          })
          .catch();
      } else {
        this.modeNote = 'create';
        this.titleModalNote = 'Ajout de nouvelle note';
        this.formNote.reset();
        this.formNote.clear();
      }

      await this.$bvModal.show('modal-note');
    },
    async editNoteModal(id) {
      this.titleModalNote = "Edition d'une note";
      this.formNote.reset();
      this.formNote.clear();
      this.modeNote = 'edit';

      await window.axios
        .get(URL.NOTE + '/' + id)
        .then((resp) => {
          Object.assign(this.formNote, resp.data.tacheNote);
        })
        .catch();

      await this.$bvModal.show('modal-note');
    },
    submitNote() {
      this.formNote.tache = this.currentTache.uuid;
      this.$bvModal.hide('modal-note');
      if (this.formNote.id) {
        //update
        this.formNote
          .put(URL.NOTE + '/' + this.formNote.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formNote.reset();
            this.formNote.clear();
            this.$refs.datatableNote.loadItems();
          })
          .catch((err) => {
            this.formNote.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-note');
          });
      } else {
        //store
        this.formNote
          .post(URL.NOTE)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formNote.reset();
            this.formNote.clear();
            this.$refs.datatableNote.loadItems();
          })
          .catch((err) => {
            this.formNote.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-note');
          });
      }
    },
    onSelectNoteRows(isSelectNote) {
      this.isSelectNote = isSelectNote;
    },
    deleteAllSelectionNote() {
      this.deleteNoteRows(this.$refs.datatableNote.idsRowsSelected);
    },
    deleteNoteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.NOTE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableNote.loadItems();
                this.isSelectNote = false;
              })
              .catch();
          }
        });
      }
    },

    /** FIN */

    init() {
      let id = this.$route.params.id;
      window.axios
        .get(URL.TACHE + '/' + id)
        .then((resp) => {
          this.currentTache = resp.data.tache;
        })
        .catch(() => {});
    },
    submit() {},
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
